import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.CALENDAR.TEXT',
        link: '/',
        parentId: 30
    },
];
